export const NumberFormatter = (num) => {
  let number = Number(num);
  if (!number) return "00.00";
  let value =
    Math.abs(number) >= 1000
      ? number % 1 != 0
        ? (Math.round(number * 100) / 100).toLocaleString()
        : number.toLocaleString() + ".00"
      : number.toFixed(2);

  return value;
};

export const convertToRomanizeSize = (num) => {
  var lookup = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
    },
    roman = "",
    i;
  for (i in lookup) {
    while (num >= lookup[i]) {
      roman += i;
      num -= lookup[i];
    }
  }
  return roman;
};
